import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerQueuePost = {
    path: "/scanner/queue",
    method: RouteHttpVerb.POST
};
export { locationRestScannerQueuePost };
